import type { FaireProductEntity } from "../../entity_types/product";

export const p_qv3mt57ht5: FaireProductEntity = {
  token: "p_qv3mt57ht5",
  type: "product",
  name: "Poolside - Luxury Summer Soy Candle - 9.75 oz",
  brandToken: "b_ggk3ftnbuv",
  brandName: "Hotel Lobby Candle",
  imageUrl:
    "https://cdn.faire.com/fastly/0f442cf35251658c225affed9af1f98e7835dd611cf10a3219d1a9eac30ab837.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bfa930172688118ced11545f5f6dc53d2ddacb716e06f5d1863c94b59988b1da.png",
    "https://cdn.faire.com/fastly/860573156173762374dffb258b716c72fe616e9af4ca2127ad66a58909dcd198.png",
    "https://cdn.faire.com/fastly/0260fba00dd69b4407f9668f57d263f63ccc996b80f1928b664359c4ca2c7da6.jpeg",
    "https://cdn.faire.com/fastly/cdca597115dceb6f77de773f07896025ec743a02c62b65223fe234665adaf999.png",
    "https://cdn.faire.com/fastly/7e9dc4d95dd48d7242dba9fac0dee83419e2295cfc5f30facb326d9a05f8011c.png",
    "https://cdn.faire.com/fastly/7357c7cccbb4b4f66f2e3b4c5a7bd8227d85b6aa6e026c70176d9ba21fd8db65.png",
  ],
  priceDollars: 29,
  description:
    "Take a deep dive into Poolside, an airy, aquatic fragrance with notes of neroli, shimmering poolwater, and crisp citrus zest. A nostalgic nod to your favorite vacation memory, Poolside captures the essence of a cool breeze, sun-kissed skin, and the plush pool towel that awaits after your first dip. \n * Notes: Poolwater, bergamot zest, neroli, wet skin, Sorrento lemon \n * Burn Time: 65 hours\n\n * Size: 9.75oz \n * 100% soy wax, braided cotton wick \n * Signature white box with ribbon \nOur hand-painted glass vessels are designed to be repurposed—which means the fun doesn’t have to end when the wax does.\n\n\n\nThis candle is currently not part of our subscription program due to seasonality.",
  tags: [],
  msrpDollars: 58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:01.073Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
